import { DEBUG } from '@glimmer/env';

export function apiDownload(...args) {
  const options = args.pop();
  if (DEBUG) {
    if (!args.length) {
      console.error(
        `Missing \`api-download\` helper file type argument (expected: "csv" or "json").`
      );
    }
  }
  const [ type ] = args;
  const { getOwner, data: { apiRequest } } = options.data.root;
  const owner = getOwner();
  const { filename, outputId, isModeled, all } = apiRequest || {};
  if (all) {
    return owner.lookup('service:model/time-series-download-all')
      .getUrl({ type, filename });
  } else if (outputId) {
    return owner.lookup('service:model/time-series-download')
      .getUrl({ [ isModeled ? 'modelRunId' : 'itemId' ]: outputId, type, filename });
  }
}
